import { twMerge } from "tailwind-merge";

/**
 * Control position type - matches standard map control positions
 */
export type ControlPosition = "top-left" | "top-right" | "bottom-left" | "bottom-right";

/**
 * Get Tailwind classes for positioning a map control
 * @param position - The corner where the control should be positioned
 * @returns Tailwind classes for absolute positioning with z-index
 */
export function getControlPositionClasses(position: ControlPosition = "top-right"): string {
  switch (position) {
    case "top-left":
      return "absolute top-4 left-4 z-10";
    case "top-right":
      return "absolute top-4 right-4 z-10";
    case "bottom-left":
      return "absolute bottom-4 left-4 z-10";
    case "bottom-right":
      return "absolute bottom-4 right-4 z-10";
    default:
      return "absolute top-4 right-4 z-10";
  }
}

/**
 * Base button classes for map controls
 * Provides consistent sizing, background, and hover states
 * Larger on mobile (48x48px) for better touch targets, standard on desktop (40x40px)
 */
export const CONTROL_BUTTON_BASE_CLASSES =
  "h-12 w-12 md:h-10 md:w-10 p-0 bg-background-surface hover:bg-background-hover shadow-lg border border-border";

/**
 * Get merged Tailwind classes for a control button
 * @param additionalClasses - Additional classes to merge with base classes
 * @returns Merged Tailwind classes
 */
export function getControlButtonClasses(additionalClasses?: string): string {
  return twMerge(CONTROL_BUTTON_BASE_CLASSES, additionalClasses);
}
